<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool">
      <template slot="text">疲劳驾驶规则列表</template>
      <template slot="btn"
        ><Button @click="getList" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openkBlind(row, index)">绑定</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增规则' : '编辑规则'"
      width="700"
      ref="formModel"
    >
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>

    <blind ref="blind" v-model="deviceList" @blind="blind"></blind>
  </div>
</template>
<script>
var categorys = [];
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "所属单位",
          key: "groupName",
          sort: 1,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          sort: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          sort: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 180,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        drivingDuration: 0,
        enabled: true,
        name: "",
        restDuration: 0,
        groupId: "",
        groupName: "",
        remark: "",
        timeList: [],
        validStayDuration: 0,
        weekList: [],
      },
      forms: [
        {
          title: "规则名称",
          key: "name",
          multiple: true,
          type: "Input",
          required: true,
        },
        /*  {
          title: "触发时长/分钟",
          key: "validStayDuration",   
          type: "InputNumber",
        }, */

        {
          title: "行车时长/分",
          key: "drivingDuration",
          key2: "drivingDuration2",
          type: "duration",
          beishu:60
        },

         {
          title: "休息时长/分",
          key: "restDuration",
          key2: "restDuration2",
          type: "duration",
          beishu:60
        },
        {
          title: "是否启用",
          key: "enabled",
          type: "bool",
          noTable: true,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
        },
      ],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        /*{
          title: "报警类型",
          key: "enabled",
          type: "Select",
          selectType: "obj",
          selectItems: [
            { name: "超速报警", id: 1 },
            { name: "断电报警", id: 2 },
          ],
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        },*/
      ],
      total: 0,
      deviceList: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-common-server-rule/fatigue/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].drivingDuration2 = Math.ceil(data[i].drivingDuration / 60);
          data[i].restDuration2 = Math.ceil(data[i].restDuration / 60);
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-common-server-rule/fatigue/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-common-server-rule/fatigue/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-common-server-rule/fatigue/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //carTypeCategory
    getDictionary() {
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "alarmType",
        },
      }).then((res) => {
        var a = JSON.parse(res.data.data.value);

        categorys.splice(0, 100);
        for (const i in a) {
          categorys.push(a[i]);
        }
      });
    },
    selectCartype(x) {
      this.selectIcon = x.value;
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    getItem(row) {
      ///cloud-common-server-rule/push/bind
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-common-server-rule/fatigue/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide();
        var d = res.data.data.deviceList;
        this.deviceList = [];
        for (let i = 0; i < d.length; i++) {
          var obj = {
            id: d[i].deviceId,
            name: d[i].bindAttr,
            key: d[i].deviceId,
            useType: d[i].useType,
          };
          this.deviceList.push(obj);
        }
        this.$refs.blind.open(row);
      });
    },
    //点击绑定按钮
    openkBlind(row) {
      this.getItem(row);
      this.blindId = row.id;
    },

    blind(data) {
      this.utils.loading(this, "处理中");
      var deviceIdList = [];
      for (let i = 0; i < data.length; i++) {
        deviceIdList.push(data[i].id);
      }
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-common-server-rule/fatigue/bind",
        data: { deviceIdList: deviceIdList, id: this.blindId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
    this.getDictionary();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/rule/fatigue.vue